import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import FilterHeader from "views/lib/components/filter/filter-header";

class StoriesFilters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filters: {}
    };
  }

  render() {
    const {
      isOpen
    } = this.state;

    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title={
            <div>
              Stories
              <Link
                className="btn btn-success btn-sm ml-2"
                to="/stories/new/0"
                title="Create new story"
              >
                <FontAwesomeIcon icon={faPlus}/>
              </Link>
            </div>
          }
          totalCount={false}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
          noExpand={true}
        />
      </Card>
    );
  }
}

export default StoriesFilters;



// WEBPACK FOOTER //
// ./src/views/pages/stories/filters.js